import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const useGSAP = () => {
  useEffect(() => {
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // Set up default GSAP configurations
    gsap.config({
      nullTargetWarn: false,
    });

    // Set up global timeline
    const tl = gsap.timeline();

    // Clean up on component unmount
    return () => {
      tl.kill();
      ScrollTrigger.getAll().forEach((trigger: any) => trigger.kill());
    };
  }, []);
};